<template>
  <div>
    <p>{{ $g("rejectReason") }}:</p>
    <div>{{ content }}</div>
  </div>
</template>

<script>
export default {
  props: {
    content: {
      type: String,
      default: "",
    },
  },
};
</script>

<style></style>
